import { Component, Input } from '@angular/core';
import { ExternalMember } from '../../../shared/models/member/external-member.model';

@Component({
  selector: 'def-password-input',
  templateUrl: './password-input.component.html',
  styleUrls: ['./password-input.component.scss'],
})
export class PasswordInputComponent {
  @Input() member: ExternalMember;

  password = '';
  confirmationPassword = '';

  onChange() {
    this.member.plainPassword = this.getPlainPassword();
  }

  /**
   * Returns user password based on its password and confirmation password
   * Returns an empty string if one of them is invalid, causing an error from the BFF
   */
  private getPlainPassword(): string {
    if (this.password !== this.confirmationPassword) {
      return '';
    }

    if (this.password === '') {
      return '';
    }

    return this.password;
  }
}
